<template>
  <Form ref="form" :model="cur" :rules="rule" :label-width="80" label-position="right">
    <FormItem
      label="标题"
      prop="alias"
      style="display: inline-block; width: 280px; margin-right: 15px;margin-bottom: 10px;"
    >
      <Input v-model="cur.alias" :maxlength="20" />
    </FormItem>
  </Form>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cur: {
        alias: '',
      },
      rule: {
        alias: [
          {
            required: true,
            message: '请填写标题',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写标题',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    this.cur.alias = this.title
  },
  watch: {
    title(newVal) {
      this.cur.alias = newVal;
    }
  },
  methods: {
    validate(params, type) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { alias } = this.cur
          let p = Object.assign({}, params, { alias })
          this.$emit('valid', p, type)
        }
      })
    },
  },
}
</script>
<style lang="less"></style>
